import _ from 'underscore';

function onAfterFindAll(options, data = {}) {
  if (_.any(data.errors, err => err.Code === 'TooMuchDataToDownload')) {
    this.showTooMuchDataError = true;
  }
  return data;
}

export function setUpErrorHandling({
  gridView,
  dataSource,
  i18n,
  scope,
}) {
  const view = gridView;
  // eslint-disable-next-line no-param-reassign
  dataSource.options.afterFindAll = _.bind(onAfterFindAll, view);
  view.showTooMuchDataError = false;
  view.tooMuchDataErrorText = (scope && scope.campaignId ?
    i18n.getString('Grid_SearchTerm_TooMuchDataError_CmpLvl') :
    i18n.getString('Grid_SearchTerm_TooMuchDataError'));
}

